// import { put, takeLatest } from "redux-saga/effects";
// import AxiosCustom from "../../../common/components/apiConfig";
// import {
// 	handleNotificationAlertCatch,
// 	handleNotificationAlertTrySelect,
// } from "../../../common/method/handleNotificationAlert";

// // import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

// export const actionTypes = {
// 	activateT0Payment: "activateT0Payment [Action]",
// 	activateT0PaymentLoading: "activateT0PaymentLoading [Action]",
// 	activateT0PaymentAsync: "activateT0PaymentAsync [Action]",
// };
// const inistiaState = {
// 	data: [],
// 	loading: false,
// 	total: 0,
// };

// export const activateT0PaymentReducer = (
// 	state = inistiaState,
// 	{ type, payload },
// ) => {
// 	switch (type) {
// 		case actionTypes.activateT0Payment:
// 			return {
// 				...state,
// 				data: payload?.results,
// 				total: payload?.total,
// 			};
// 		case actionTypes.activateT0PaymentLoading:
// 			return {
// 				...state,
// 				loading: payload,
// 			};
// 		default:
// 			return state;
// 	}
// };

// function* handleWorker({ payload }) {
// 	yield put({
// 		type: actionTypes.activateT0PaymentLoading,
// 		payload: true,
// 	});

// 	let config = {
// 		url: "insert_request",
// 	};

// 	let data = {
// 		table: "payment",
// 		method_type: "activate_t0_payment",
// 		data: payload?.data ? payload.data : {},
// 	};

// 	try {
// 		let res = yield AxiosCustom(config, data);
// 		let isOk = handleNotificationAlertTrySelect(res);
// 		if (!isOk) {
// 			return;
// 		}

// 		yield put({
// 			type: actionTypes.activateT0Payment,
// 			payload: res?.data?.response?.data,
// 		});
// 	} catch {
// 		handleNotificationAlertCatch();
// 	} finally {
// 		yield put({
// 			type: actionTypes.activateT0PaymentLoading,
// 			payload: false,
// 		});
// 	}
// }

// export function* activateT0Payment() {
// 	yield takeLatest(actionTypes.activateT0PaymentAsync, handleWorker);
// }

import AxiosCustom from "../../../common/components/apiConfig";

export const activate_t0_payment = (data) => {
	let config = { url: "insert_request" };

	let _data = {
		table: "payment",
		method_type: "activate_t0_payment",
		data: {
			...data,
		},
	};

	return AxiosCustom(config, _data);
};
